import React from 'react';
import { useTranslation } from 'react-i18next';

const TwitterSection = () => {
  const { i18n } = useTranslation();

  const accreditations = [
    {
      id: 1,
      image: '/images/saudi-bar-association.png',
      nameAr: 'الهيئة السعودية للمحامين',
      nameEn: 'Saudi Bar Association',
      headlineAr: 'معتمد لدى الهيئة السعودية للمحامين',
      headlineEn: 'Accredited by the Saudi Bar Association',
      sublineAr: 'اعتماد مهني يعزز الثقة والموثوقية',
      sublineEn: 'Professional accreditation that reinforces trust',
      descriptionAr: 'يعكس هذا الاعتماد التزام وازن بالممارسة القانونية المنضبطة والمعايير المهنية المعتمدة.',
      descriptionEn: 'This accreditation reflects Wazin’s commitment to disciplined legal practice and approved professional standards.',
      imageClassName: 'max-h-64 md:max-h-72 object-contain'
    },
    {
      id: 2,
      image: '/images/saip.svg',
      nameAr: 'الهيئة السعودية للملكية الفكرية',
      nameEn: 'Saudi Authority for Intellectual Property',
      headlineAr: 'خبرات موثوقة في الملكية الفكرية',
      headlineEn: 'Trusted Experience in Intellectual Property',
      sublineAr: 'خبرة متخصصة في حماية الحقوق والأصول',
      sublineEn: 'Specialized expertise in rights and asset protection',
      descriptionAr: 'تدعم خبرات وازن حماية الحقوق وتعزيز القيمة القانونية في ملفات الملكية الفكرية.',
      descriptionEn: 'Wazin’s experience supports rights protection and strengthens legal value across intellectual property matters.',
      imageClassName: 'max-h-[24rem] md:max-h-[28rem] object-contain'
    },
    {
      id: 3,
      image: '/images/hrsd.png',
      nameAr: 'وزارة الموارد البشرية والتنمية الاجتماعية',
      nameEn: 'Ministry of Human Resources and Social Development',
      headlineAr: 'إلمام تنظيمي ببيئة العمل والموارد البشرية',
      headlineEn: 'Regulatory Understanding of Workplace and HR',
      sublineAr: 'مواكبة تنظيمية تدعم الامتثال المؤسسي',
      sublineEn: 'Regulatory alignment that supports compliance',
      descriptionAr: 'نواكب الأطر النظامية ذات الصلة بما يدعم الامتثال والاستقرار المؤسسي.',
      descriptionEn: 'We keep pace with relevant regulatory frameworks to support compliance and organizational stability.',
      imageClassName: 'max-h-64 md:max-h-72 object-contain'
    }
  ];

  return (
    <section className="py-24 px-4 bg-white" id="social">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-wazin-navy mb-4">
            {i18n.language === 'ar' ? 'اعتماداتنا وشراكاتنا' : 'Our Accreditations & Partnerships'}
          </h2>
          <p className="text-xl md:text-2xl text-wazin-navy/80 max-w-4xl mx-auto leading-relaxed font-medium">
            {i18n.language === 'ar'
              ? 'نفخر بعلاقاتنا المهنية واعتماداتنا التي تعكس موثوقية وازن، وتعزز جودة خدماتنا القانونية للأفراد وقطاع الأعمال.'
              : 'We take pride in our professional relationships and accreditations, which reflect Wazin’s credibility and strengthen the quality of our legal services for individuals and businesses.'}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8">
          {accreditations.map((item) => (
            <div
              key={item.id}
              className="group rounded-[28px] overflow-hidden transition-all duration-300 border border-[#d8c39a] shadow-[0_18px_45px_rgba(15,23,42,0.10)] hover:shadow-[0_24px_60px_rgba(15,23,42,0.14)] bg-white isolate"
              style={{ backgroundColor: '#ffffff', opacity: 1 }}
              dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
            >
              <div className="h-full flex flex-col">
                <div
                  className={`px-6 md:px-8 pt-6 md:pt-7 pb-4 border-t-4 min-h-[230px] md:min-h-[250px] flex items-center justify-center ${
                    item.id === 2 ? 'border-wazin-navy' : 'border-wazin-gold'
                  }`}
                >
                  <img
                    src={item.image}
                    alt={i18n.language === 'ar' ? item.nameAr : item.nameEn}
                    className={`w-full ${item.imageClassName} group-hover:scale-[1.02] transition-transform duration-300`}
                  />
                </div>

                <div className="px-7 md:px-8 pt-6 pb-8 border-t border-[#eadfc8] text-center min-h-[290px] flex flex-col">
                  <h3 className="text-[1.32rem] md:text-[1.46rem] font-bold text-wazin-navy mb-3 leading-[1.45] min-h-[70px] flex items-center justify-center">
                    {i18n.language === 'ar' ? item.headlineAr : item.headlineEn}
                  </h3>
                  <h4 className="text-[1rem] md:text-[1.06rem] font-bold text-[#8f6b2d] mb-4 leading-[1.6] min-h-[52px] flex items-center justify-center">
                    {i18n.language === 'ar' ? item.sublineAr : item.sublineEn}
                  </h4>
                  <p className="text-wazin-navy/80 leading-8 text-[0.98rem] md:text-[1rem] font-medium min-h-[88px] max-w-[34ch] mx-auto flex items-start justify-center">
                    {i18n.language === 'ar' ? item.descriptionAr : item.descriptionEn}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TwitterSection;
